import { Controller } from "@hotwired/stimulus"

// Progressive enhancement: without JavaScript all three examples stay readable.
export default class extends Controller {
  static targets = ["tablist", "tab", "panel"]

  connect() {
    this.tablistTarget.setAttribute("role", "tablist")
    this.tabTargets.forEach(tab => tab.setAttribute("role", "tab"))
    this.panelTargets.forEach(panel => {
      panel.setAttribute("role", "tabpanel")
      panel.setAttribute("tabindex", "0")
    })
    this.activate(0)
  }

  select(event) { this.activate(Number(event.currentTarget.dataset.index)) }
  jump(event) { this.activate(Number(event.currentTarget.dataset.index), true) }

  navigate(event) {
    const current = this.tabTargets.indexOf(event.currentTarget)
    const last = this.tabTargets.length - 1
    const next = { ArrowRight: (current + 1) % (last + 1), ArrowLeft: (current + last) % (last + 1), Home: 0, End: last }[event.key]
    if (next === undefined) return
    event.preventDefault()
    this.activate(next, true)
  }

  activate(index, focus = false) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === index))
      tab.tabIndex = i === index ? 0 : -1
    })
    this.panelTargets.forEach((panel, i) => { panel.hidden = i !== index })
    if (focus) this.tabTargets[index].focus()
  }
}
